import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-social-auth-callback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './social-auth-callback.component.html',
})
export class SocialAuthCallbackComponent implements OnInit {
  message = '';
  isLoading = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Handle ?error query param
    const error = this.route.snapshot.queryParamMap.get('error');
    if (error) {
      this.isLoading = false;
      this.message = decodeURIComponent(error);
      return;
    }

    // Handle ?action=link_required query param
    const action = this.route.snapshot.queryParamMap.get('action');
    if (action === 'link_required') {
      this.isLoading = false;
      this.message = 'Te enviamos un email para confirmar la vinculación de tu cuenta';
      return;
    }

    // Extract token from URL fragment: #token=...&scope=...
    const fragment = window.location.hash.substring(1); // remove leading '#'
    const params = new URLSearchParams(fragment);
    const token = params.get('token');
    const scope = params.get('scope');
    const sessionId = params.get('sessionId');

    if (!token) {
      this.isLoading = false;
      this.message = 'Error: no se recibió un token válido.';
      return;
    }

    try {
      const decodedUser = this.decodeJwtPayload(token);

      this.authService.setToken(token);
      this.authService.setUser(decodedUser as any);
      if (sessionId) {
        this.authService.setSessionId(sessionId);
        // Canjear el sessionId por la cookie httpOnly del refresh token
        this.authService.exchangeSocialToken(sessionId).subscribe({ error: () => {} });
      }

      history.replaceState(null, '', window.location.pathname);

      // Redirect based on scope
      if (scope === 'onboarding') {
        this.router.navigate(['/completar-perfil']);
      } else {
        this.router.navigate(['/']);
      }
    } catch (e) {
      this.isLoading = false;
      this.message = 'Error al procesar la autenticación. Por favor, intentá de nuevo.';
    }
  }

  private decodeJwtPayload(token: string): object {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format');
    }
    const payload = parts[1];
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const decoded = atob(padded);
    return JSON.parse(decoded);
  }
}
